import { NavLink } from 'react-router-dom';
import { useContext } from "react"
import { AuthContext } from "../../contexts/AuthContext"
import { ParameterContext } from '../../contexts/ParameterContext';
export default function SideBar() {

    const { user } = useContext(AuthContext);

    const { parameters, version } = useContext(ParameterContext)

    let directorApplicationsEnabled;

    if (parameters && parameters.nomParameters) {
        const directorApplicationsEnabledParam = parameters.nomParameters.find(x => x.param_name == 'DIRECTOR_APPLICATIONS_ENABLED');
        directorApplicationsEnabled = directorApplicationsEnabledParam ? directorApplicationsEnabledParam.value : 1;
    }

    const isRestrictedDirector = user.role === "Director" && directorApplicationsEnabled == 0;

    let disableAnulDir;

    if (parameters && parameters.nomParameters) {
        const disableAnulDirParam = parameters.nomParameters.find(x => x.param_name == 'DISABLE_ANUL_DIR');

        disableAnulDir = disableAnulDirParam ? disableAnulDirParam.value : 0;
    } else {
        disableAnulDir = 0;
    }

    return (
        <aside id="sidebar" className="sidebar">

            <ul className="sidebar-nav" id="sidebar-nav">

                <li className="nav-item">
                    <NavLink to="/schadm/" className="nav-link collapsed">
                        <i className="ri-home-5-line"></i>
                        <span>Начало</span>
                    </NavLink>
                </li>

                {!isRestrictedDirector && (
                <>
                    <li className="nav-heading">Заявления</li>


                    {
                        user.role === "Director" ?
                            <li className="nav-item">
                                <NavLink to="register" className="nav-link collapsed">
                                    <i className="ri-add-box-line"></i>
                                    <span>Ново заявление</span>
                                </NavLink>
                            </li>
                            :
                            ''
                    }

                    {
                        (user.role === "SuperAdmin" || user.role === "Admin" || user.role === "Municipality") ?
                            <li className="nav-item">
                                <NavLink to="register/municipality" className="nav-link collapsed">
                                    <i className="ri-add-box-line"></i>
                                    <span>Ново заявление (Община)</span>
                                </NavLink>
                            </li>
                            :
                            ''
                    }

                    <li className="nav-item">
                        <NavLink to="editreg" className="nav-link collapsed">
                            <i className="ri-edit-box-line"></i>
                            <span>Редакция на заявление</span>
                        </NavLink>
                    </li>

                    {disableAnulDir == 1 && user.role == 'Director'
                        ? <></>
                        : <li>
                            <NavLink to="annul-reg" className="nav-link collapsed">
                                <i className="ri-delete-back-2-line"></i>
                                <span>Анулиране на заявление</span>
                            </NavLink>
                        </li>
                            }
                </>
             )}


                {user.role != 'Municipality' && user.role != 'Parent' &&
                    <>
                        <li className="nav-heading">Класиране</li>

                        <li>
                            <NavLink to="conf-admission" className="nav-link collapsed">
                                <i className="ri-check-fill"></i>
                                <span>Потвърждаване на прием</span>
                            </NavLink>
                        </li>

                        <li>
                            <NavLink to="unsubscribe" className="nav-link collapsed">
                                <i className="ri-arrow-go-back-fill"></i>
                                <span>Отписване</span>
                            </NavLink>
                        </li>
                    </>
                }

                <li className="nav-heading">Справки</li>

                <li>
                    <NavLink to="pending-rating" className="nav-link collapsed">
                        <i className="ri-time-line"></i>
                        <span>Чакащи класиране</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="ranked-childrens" className="nav-link collapsed">
                        <i className="bi bi-graph-up"></i>
                        <span>Класирани деца</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="all-conf" className="nav-link collapsed">
                        <i className="ri-checkbox-line"></i>
                        <span>Всички потвърдени</span>
                    </NavLink>
                </li>

                {(user.role == 'SuperAdmin' || user.role == 'Admin') &&
                    <li>
                        <NavLink to="bookOfActions" className="nav-link collapsed">
                            <i className="ri-calendar-2-line"></i>
                            <span>Дневник на дейности</span>
                        </NavLink>
                    </li>
                }

                {/*<li>*/}
                {/*    <NavLink to="all-enroled" className="nav-link collapsed">*/}
                {/*        <i className="ri-contacts-book-line"></i>*/}
                {/*        <span>Всички записани</span>*/}
                {/*    </NavLink>*/}
                {/*</li>*/}

                <li className="nav-heading">Архив</li>

                <li>
                    <NavLink to="archive" className="nav-link collapsed">
                        <i className="ri-archive-line"></i>
                        <span>Архив</span>
                    </NavLink>
                </li>

                {user.role != 'Director' && user.role != 'Parent' &&
                    <>
                        <li className="nav-heading">Съдържание</li>
                        <li className="nav-item">
                            <a className="nav-link collapsed" data-bs-target="#forms-nav" data-bs-toggle="collapse" href="#">
                                <i className="bi bi-journal-text"></i><span>Промяна съдържание</span><i className="bi bi-chevron-down ms-auto"></i>
                            </a>
                            <ul id="forms-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                                <li className="nav-heading">Новини</li>
                                <li>
                                    <NavLink to="main-page-news" className="nav-link collapsed">
                                        <i className="bi bi-circle"></i><span>Новина начална страница</span>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="all-news" className="nav-link collapsed">
                                        <i className="bi bi-circle"></i><span>Виж всички новини</span>
                                    </NavLink>
                                </li>
                                <li className="nav-heading">Наредби</li>
                                <li>
                                    <NavLink to="add-rules" className="nav-link collapsed">
                                        <i className="ri-file-info-line"></i>
                                        <span>Добави наредби</span>
                                    </NavLink>
                                </li>
                                <li className="nav-heading">График</li>
                                <li>
                                    <NavLink to="change-schedule" className="nav-link collapsed">
                                        <i className="ri-alarm-line"></i>
                                        <span>Промени график</span>
                                    </NavLink>
                                </li>
                                <li className="nav-heading">Чужденци</li>
                                <li>
                                    <NavLink to="foreigners" className="nav-link collapsed">
                                        <i className="bi bi-circle"></i><span>Указания чужденци</span>
                                    </NavLink>
                                </li>

                            </ul>
                        </li>

                    </>

                }

                {(user.role == 'SuperAdmin' || user.role == 'Admin') &&
                    <>
                        <li className="nav-heading">Настройки</li>

                        <li>
                            <NavLink to="manageUsers" className="nav-link collapsed">
                                <i className="ri-user-settings-line"></i>
                                <span>Управление на потребители</span>
                            </NavLink>
                        </li>
                    </>
                }

                {user.role == 'SuperAdmin' &&
                    <li>
                        <NavLink to="show-conf-system" className="nav-link collapsed">
                            <i className="ri-settings-5-line"></i>
                            <span>Системни настройки</span>
                        </NavLink>
                    </li>
                }

                {user.role == 'SuperAdmin' &&
                    <li>
                        <NavLink to="show-sys-version" className="nav-link collapsed">
                            <i class="ri-star-fill"></i>
                            <span>Актуална версия</span>
                        </NavLink>
                    </li>
                }

                

                <li className="nav-heading"><hr /></li>

                <li>
                    <a href={`documents/manuals/manual_dir.pdf`} target="_blank" rel="noopener noreferrer" className="nav-link collapsed">
                        <i className="ri-book-mark-line"></i>
                        <span>Ръководство</span>
                    </a>
                </li>

               

                <li>
                    <NavLink className="nav-link collapsed" to="logout">
                        <i className="ri-logout-box-line"></i>
                        <span>Изход</span>
                    </NavLink>
                </li>

            </ul>

        </aside>
    )
}